/**
 * Society hub URL helpers: paths and pathname parsing for SocietyDetailPage
 * and SocietyInternalNav (section ids must match route segments under /societies/:id/).
 */

/** Path for society overview or `/societies/:id/:section`. */
export function getSocietyHubPath(societyIdentifier, section) {
  if (!societyIdentifier) return '';
  return section === 'details'
    ? `/societies/${societyIdentifier}`
    : `/societies/${societyIdentifier}/${section}`;
}

/**
 * Section id for SocietyInternalNav from a society hub pathname (first tab segment only).
 * `/societies/:slug/free` maps to `free-items` (nav id). Base `/societies/:slug` → details.
 */
export function deriveSocietyHubSectionFromPathname(pathname) {
  if (!pathname || typeof pathname !== 'string') return 'details';
  const trimmed = pathname.replace(/\/+$/, '');
  const parts = trimmed.split('/').filter(Boolean);
  if (parts.length < 3 || parts[0] !== 'societies') {
    return 'details';
  }
  const segment = parts[2];
  if (segment === 'free') return 'free-items';
  return segment;
}
